import { z } from 'zod';

export const personSchema = z.object({
  id: z.string(),
  username: z.string(),
  display_name: z.string(),
  // Sessions stored before accounts had an email read as ''; the next profile refresh fills it.
  email_address: z.string().default(''),
});

export type Person = z.infer<typeof personSchema>;
